"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlTemplate = void 0;
var tslib_1 = require("tslib");
var control_dot_1 = (0, tslib_1.__importDefault)(require("./control.dot"));
var controlTemplate = control_dot_1.default.default ? control_dot_1.default.default : control_dot_1.default;
exports.controlTemplate = controlTemplate;
//# sourceMappingURL=index.js.map